<template>
  <b-modal
    ref="game-creator-modal"
    hide-footer
    :title="modalTitle"
    @show="resetModal"
    @hidden="resetModal"
    size="lg"	
  >
    <form
      id="game-cat-form"
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >

      <b-form-group
        label="สถานะ"
        label-class="text-primary"
        v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-status"
          v-model="input.status"
          :options="statusOptions"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        label="หมวดเกม"
        label-class="text-primary"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          id="radio-creator-cat"
          v-model="input.catId"
          :options="catOptions"
          :aria-describedby="ariaDescribedby"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        label="ชื่อค่ายเกม"
        label-class="text-primary"
      >
        <b-form-input
          id="input-creator-name"
          v-model="input.name"
          type="text"
          placeholder="ชื่อค่ายเกม"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="productId"
        label-class="text-primary"
      >
        <b-form-input
          id="input-creator-product-id"
          v-model="input.productId"
          type="text"
          placeholder="productId"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="เรียงลำดับ"
        label-class="text-primary"
      >
        <b-form-input
          id="input-creator-sort"
          v-model="input.sort"
          type="text"
          placeholder="เรียงลำดับ"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="ตั้งค่า betLimit"
        label-class="text-primary"
      >
        <b-form-textarea
          id="input-creator-bet-limit"
          v-model="input.betLimit"
          placeholder="ใส่ค่าเป็น json ตามรูปแบบที่กำหนด"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group
        label="Url รูปหน้าปก"
        label-class="text-primary"
      >
        <b-form-input
          id="input-creator-image"
          v-model="input.image"
          type="text"
          placeholder="https://example.com/image.jpg"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="เพิ่ม/อัพเดต เกม"
        label-class="text-primary"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          id="radio-add-games"
          v-model="input.autoAddGame"
          :options="addOptions"
          :aria-describedby="ariaDescribedby"
        ></b-form-radio-group>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" size="sm" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="isProcess || !input.name">{{isProcess ? 'กำลังบันทึก...' : 'บันทึก'}}</b-button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import GameService from '@/services/gameService'
import Swal from 'sweetalert2'

export default {
  name: 'GameCreatorModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    cats: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    data: {
      type: Object,
      default: {
        _id: null,
        catId: null,
        name: null,
        productId: null,
        autoAddGame: false,
        sort: 0,
        status: 'Active',
        betLimit: null,
        image: null
      }
    }
  },
  data() {
    return {
      addOptions: [{
        text: 'ใช่',
        value: true
      }, {
        text: 'ไม่ใช่',
        value: false
      }],
      input: {
        _id: null,
        catId: null,
        name: null,
        productId: null,
        autoAddGame: false,
        sort: 0,
        status: 'Active',
        betLimit: null,
        image: null
      },
      isProcess: false,
      needReload: false
    }
  },
  computed: {
    modalTitle() {
      return this.input._id ? 'แก้ไขค่ายเกม' : 'เพิ่มค่ายเกม'
    },
    statusOptions() {
      return [
        { text: 'ใช้งาน', value: 'Active' },
        { text: 'ไม่ใช้งาน', value: 'Inactive' }
      ]
    },
    catOptions() {
      return this.cats.map((cat)=>{
        return {
          text: cat.name,
          value: cat._id
        }
      })
    },
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    data() {
      this.input = JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    resetModal() {
      this.needReload = false
    },
    showModal() {
      this.$refs['game-creator-modal'].show()
    },
    hideModal() {
      this.$refs['game-creator-modal'].hide()
    },
    handleSubmit() {
      if(this.input._id) {
        this.update()
      }else{
        this.save()
      }
    },
    save() {
      if(this.input.name) {
        GameService.saveCreator(this.input)
        .then((response)=>{
          if(response.success) {
            this.needReload = true
            this.hideModal()
          }else{
            throw new Error(response?.message)
          }
        })
        .catch((e)=>{

          Swal.fire({
            title: 'ผิดพลาด!',
            text: e?.message || 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
      }
    },
    update() {
      if(this.input.name) {
        GameService.updateCreator(this.input._id, this.input)
        .then((response)=>{
          if(response.success) {
            this.needReload = true
            this.hideModal()
            this.$notify({
              type: 'success',
              title: 'สำเร็จ!',
              text: 'บันทึกเสร็จเรียบร้อย',
            })
          }else{
            throw {
              massage: response
            }
          }
        })
        .catch((e)=>{
          Swal.fire({
            title: 'ผิดพลาด!',
            text: 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
      }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
